import React from 'react';
import { Button } from 'reactstrap';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { strings } from '../../constants/localization';
import TermsConditions from './TermsConditions';
import {
  trackVerticalStyle,
  thumbVerticalStyle,
} from '../../constants/styleScrollbar';
import { LoanDataOutput, AcceptanceLoanData } from '../interfaces';

interface StepThreeProps {
  processData: LoanDataOutput;
  acceptLoan: AcceptanceLoanData;
  nextStep: () => void;
  rejectLoan: () => void;
  previousStep: () => void;
  skipSliderStep?: boolean;
}

const StepThree: React.FC<StepThreeProps> = (props) => {
  const { processData, acceptLoan } = props;
  const {
    restructured,
    brand,
    clientFirstName,
    clientLastName,
    cpr,
    companyAddress,
    companyCity,
    companyZip,
    loanNumber,
    creditFacilityNumber,
    loanOwnerNameExtended,
    loanOwnerName,
  } = acceptLoan;
  const {
    setupFee,
    loanAmount,
    duration,
    interestRate,
    apr,
    totalCreditCost,
    totalRepayment,
    monthlyPayment,
    firstInstallmentDate,
    lastInstallmentDate,
  } = processData;

  const continueStep = () => {
    props.nextStep();
  };

  const rejectStep = () => {
    props.rejectLoan();
  };
  return (
    <div className='step-content step-three'>
      <h1 className='step-title'>{strings.step3Title}</h1>
      <div className='agreement-information'>
        <Scrollbars
          // eslint-disable-next-line
          renderTrackVertical={({ style, ...props }) => (
            <div
              {...props}
              style={{
                ...style,
                ...trackVerticalStyle,
              }}
            />
          )}
          // eslint-disable-next-line
          renderThumbVertical={({ style, ...props }) => (
            <div
              {...props}
              style={{
                ...style,
                ...thumbVerticalStyle,
              }}
            />
          )}
        >
          <div className='scrollbar-wrapper'>
            <TermsConditions
              type={restructured ? 'restructuring' : 'invoice'}
              brand={brand}
              clientName={`${clientFirstName} ${clientLastName}`}
              clientAddress={companyAddress}
              clientCity={companyCity}
              clientZip={parseInt(companyZip, 10)}
              loanNumber={loanNumber}
              loanAmount={loanAmount}
              setupFee={setupFee}
              duration={duration}
              interestRate={interestRate}
              apr={apr.toFixed(2)}
              cpr={cpr}
              totalCosts={totalCreditCost}
              totalRepayment={totalRepayment}
              monthlyInstallment={monthlyPayment}
              creditFacilityNumber={creditFacilityNumber}
              loanOwnerNameExtended={loanOwnerNameExtended}
              loanOwnerName={loanOwnerName}
              firstPaymentDate={firstInstallmentDate}
              lastPaymentDate={lastInstallmentDate}
            />
          </div>
        </Scrollbars>
      </div>
      <div className='step-actions'>
        <Button
          color='light'
          className='reject'
          onClick={() =>
            props.skipSliderStep ? rejectStep() : props.previousStep()
          }
        >
          {props.skipSliderStep ? strings.declineLoan : strings.goBack}
        </Button>
        <Button
          color='blue'
          className='continue'
          onClick={() => continueStep()}
        >
          {strings.acceptStep}
        </Button>
      </div>
    </div>
  );
};

export default StepThree;
